import { interpolateColor, useAnimatedStyle, useDerivedValue, withSpring } from 'react-native-reanimated';
import { useTheme } from 'styled-components/native';
import { springConfig } from '~/constants/animations';
import { PressableAnimationsProps } from '~/types/animations';

export interface DietPlanButtonAnimationsRenderPropValue {
    containerAnimationStyles: {
        backgroundColor: string;
    };
    labelAnimationStyles: {
        color: string;
    };
}

export interface DietPlanButtonAnimationsProps
    extends PressableAnimationsProps<DietPlanButtonAnimationsRenderPropValue> {}

export const DietPlanButtonAnimation = ({ progress, children }: DietPlanButtonAnimationsProps) => {
    const theme = useTheme();

    const pressableProgress = useDerivedValue(() => withSpring(progress, springConfig.default));

    const backgroundColors: Record<string, string> = {
        default: 'transparent',
        hovered: theme.palette.opacity['12'].rgba,
        pressed: theme.palette.opacity['12'].rgba,
    };

    const labelColors: Record<string, string> = {
        default: theme.text.tertiary,
        hovered: theme.text.secondary,
        pressed: theme.text.secondary,
    };

    const containerAnimationStyles = useAnimatedStyle(() => {
        return {
            backgroundColor: interpolateColor(
                pressableProgress.value,
                [0, 1, 2],
                [backgroundColors.default, backgroundColors.hovered, backgroundColors.pressed],
            ),
        };
    });

    const labelAnimationStyles = useAnimatedStyle(() => {
        return {
            color: interpolateColor(
                pressableProgress.value,
                [0, 1, 2],
                [labelColors.default, labelColors.hovered, labelColors.pressed],
            ),
        };
    });

    return children({ containerAnimationStyles, labelAnimationStyles });
};
